export default __webpack_public_path__ + "static/media/attorney_1.8f13a649.png";